import { forwardRef, useState, ChangeEventHandler, Ref } from 'react';
// eslint-disable-next-line camelcase -- это название из reakit
import { VisuallyHidden, unstable_useId } from 'reakit';

import { Box } from '../../Box/Box';
import { Field } from '../../Field/Field';
import { Inline } from '../../Inline/Inline';
import CalendarPopover from '../CalendarPopover/CalendarPopover';
import {
  externalDateValidator,
  inputToCalendarFormatConverter,
  transformDateToInputFormat,
} from '../helpers';
import type { SingleDatepickerProps } from '../types';

/**
 * @deprecated Используйте SingleFieldDatepicker
 */
export const SingleDatepicker = forwardRef(
  (
    {
      disabled,
      hasError = false,
      value,
      minDate,
      maxDate,
      disabledDates,
      initialCalendarType,
      className,
      onChange,
      ...fieldProps
    }: SingleDatepickerProps,
    ref: Ref<HTMLInputElement>
  ) => {
    const isValueValid = value && externalDateValidator(value);
    const [innerValue, setInnerValue] = useState(
      isValueValid ? transformDateToInputFormat(value) : ''
    );
    const { id } = unstable_useId();

    const selectedCalendarDate = isValueValid ? [value] : undefined;

    const handleInputChange: ChangeEventHandler<HTMLInputElement> = (event) => {
      const { value: userInputValue } = event.target;
      setInnerValue(userInputValue);
      onChange(inputToCalendarFormatConverter(userInputValue));
    };

    const handleCalendarChange = (date: string | undefined) => {
      onChange(date ?? '');
      setInnerValue(date ? transformDateToInputFormat(date) : '');
    };

    return (
      <Inline
        space="datepickerSpace"
        alignItems="flex-end"
        className={className}
      >
        <Box>
          <Field
            {...fieldProps}
            ref={ref}
            aria-autocomplete="none"
            aria-describedby={innerValue ? undefined : id}
            placeholder="ДД.ММ.ГГГГ"
            disabled={disabled}
            hasError={hasError}
            value={innerValue}
            onChange={handleInputChange}
            styles={{
              width: 'datepickerSingleFieldWidth',
              fontFeatureSettings: '"tnum"',
            }}
          />
          <VisuallyHidden id={id}>разделитель точка</VisuallyHidden>
        </Box>
        <CalendarPopover
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          disabledDates={disabledDates}
          initialCalendarType={initialCalendarType}
          selectedDate={selectedCalendarDate}
          onSelectedDateChange={handleCalendarChange}
        />
      </Inline>
    );
  }
);
